export interface RegistryFieldData {
  value: string;
  provenance: string;
  source?: string;
  asOf?: string;
  note?: string;
}

export interface RegistrySource {
  label: string;
  url: string;
  asOf: string;
}

export interface RegistryTag {
  _id: string;
  label: string;
  value: string;
}

export interface RegistryEntry {
  _id: string;
  name: string;
  issuer: string;
  assetClass: string;
  real: boolean;
  jurisdiction: string;
  structure: string;
  oracleTaxonomy: string;
  custodian: RegistryFieldData;
  minimum: RegistryFieldData;
  publishedYield: RegistryFieldData;
  aum: RegistryFieldData;
  documents: string[];
  sources: RegistrySource[];
  note?: string;
  isActive?: boolean;
  createdAt?: string;
}

export interface RegistryFormData {
  name: string;
  issuer: string;
  assetClass: string;
  real: boolean;
  jurisdiction: string;
  structure: string;
  oracleTaxonomy: string;
  custodian: RegistryFieldData;
  minimum: RegistryFieldData;
  publishedYield: RegistryFieldData;
  aum: RegistryFieldData;
  documents: string[];
  note: string;
}

export const REGISTRY_CLASSES = [
  'Treasuries',
  'Private Credit',
  'Real Estate',
  'Commodities',
  'Venture',
];

export const ORACLE_TAXONOMIES = ['attested', 'model-driven', 'hybrid', 'market-tracker'];
